import * as React from 'react'
import {Box} from "@mui/material";
import {formatProductsUnits} from "@ui-seeker/utils";


export default function percentageColumn(key, label) {
	return {
		name: key, label: label,
		options: {
			setCellHeaderProps: () => ({ sx: {
				whiteSpace: 'pre-wrap',
			}}),
			customBodyRowRenderLite: value => <Box sx={{ textAlign: 'center' }}>
				{formatProductsUnits(value)}
			</Box>
		}
	}
}